import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getActiveOperationsJson, formatApiError } from '../services/api';

const ActiveOperationsJsonPage = () => {
  const { t } = useTranslation('planning');
  const [operations, setOperations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const jsonOutput = useMemo(() => JSON.stringify(operations, null, 2), [operations]);

  useEffect(() => {
    let cancelled = false;

    const fetchActiveOperations = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getActiveOperationsJson();
        if (!cancelled) {
          setOperations(Array.isArray(response) ? response : []);
        }
      } catch (err) {
        const formatted = formatApiError(err);
        if (!cancelled) {
          setError(formatted.generalError || t('failedToLoadActiveOperations'));
          setOperations([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchActiveOperations();

    return () => {
      cancelled = true;
    };
  }, [t]);

  if (loading) {
    return (
      <pre className="m-0 min-h-screen overflow-auto bg-white p-4 text-sm leading-6 text-slate-900">
        {t('loadingActiveOperations')}
      </pre>
    );
  }

  if (error) {
    return (
      <pre className="m-0 min-h-screen overflow-auto bg-white p-4 text-sm leading-6 text-red-700">
        {JSON.stringify({ error }, null, 2)}
      </pre>
    );
  }

  return (
    <pre className="m-0 min-h-screen overflow-auto bg-white p-4 text-sm leading-6 text-slate-900">
      <code>{jsonOutput}</code>
    </pre>
  );
};

export default ActiveOperationsJsonPage;
